import { createSearchParams, useNavigate } from 'react-router';

import { GridRowModel } from '@mui/x-data-grid-pro';

import { useApplicationContext } from 'context/ApplicationContext';
import { useClientContext } from 'context/ClientContext';
import { usePermissionsContext } from 'context/PermissionsContext';

type ReturnUseNavigateToPedido = {
    navigateToPedido: (data: GridRowModel) => void;
};

export function useNavigateToPedido(): ReturnUseNavigateToPedido {
    const { hasPermission } = usePermissionsContext();
    const navigate = useNavigate();
    const hasPermissionFinalizacaoGeral = hasPermission(['COMPRA_PEDIDO_FINALIZACAO_GERAL']);
    const { user } = useApplicationContext();
    const { tipoPedido } = useClientContext();
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';

    const navigateToPedido = (rowData: GridRowModel): void => {
        const { loja, tipoEntrega, usuarioPedido, configPedido } = rowData;
        const { idLoja, cdLoja, dsNomeFantasia } = loja;
        const {
            idConfigPedido,
            dsConfigPedido,
            vlPedidoMinimoLoja,
            configPedidoRegraValidacao,
            tpControlePedidoMinimoLoja,
            idTipoControleEstoquePedido,
        } = configPedido;
        const hasUsuarioTipoEntregaAmbos = usuarioPedido.idTipoEntrega === -1; // Seleciona ambos tipo de entrega
        const isUsuarioPedidoLogged = usuarioPedido.idUsuario === user.idUsuario;
        const includeParamUsuario = isTipoPedidoFuncionario && hasPermissionFinalizacaoGeral && !isUsuarioPedidoLogged;
        const includeParamTipoEntrega = isTipoPedidoFuncionario && tipoEntrega && hasUsuarioTipoEntregaAmbos;

        navigate({
            pathname: '/compra/pedido',
            search: createSearchParams({
                idLoja: JSON.stringify({
                    idLoja,
                    cdLoja,
                    dsNomeFantasia,
                }),
                idConfigPedido: JSON.stringify({
                    idConfigPedido,
                    dsConfigPedido,
                    vlPedidoMinimoLoja,
                    configPedidoRegraValidacao,
                    tpControlePedidoMinimoLoja,
                    idTipoControleEstoquePedido,
                }),
                ...(includeParamUsuario && { idUsuarioPedido: JSON.stringify(usuarioPedido) }),
                ...(includeParamTipoEntrega && { idTipoEntrega: JSON.stringify(tipoEntrega) }),
            }).toString(),
        });
    };

    return { navigateToPedido };
}
